
export const cardExpire = (expMonth, expYear) => {
  // console.log(expMonth, expYear);
  const currentDate = new Date().toLocaleDateString();
  const currentMonth = Number(currentDate.split('/')[0]);
  const currentYear = Number(currentDate.split('/')[2]);

  if (expYear < currentYear) {
    return true;
  }
  if (expYear === currentYear && expMonth < currentMonth) {
    return true;
  }

  return false;
};


export const nearToExpire = (expMonth, expYear) => {
  // console.log(expMonth, expYear);
  const currentDate = new Date().toLocaleDateString();
  const currentMonth = Number(currentDate.split('/')[0]);
  const currentYear = Number(currentDate.split('/')[2]);

  if (expYear === currentYear && expMonth === currentMonth) {
    return true;
  }

  return false;
};


export const getCustomerCardPaymentMethods = async (
  url, 
  token,  
  customerId,
) => {
  try {
    const result = await fetch(url + `/payment-method/customer-card-payment-methods/?customerId=${customerId}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      // body: JSON.stringify({
      //   customerId: customerId,
      //   priceId: priceId,
      // }),
    })

    const resData = await result.json()

    // console.log('meterEventSummarys', resData);

    if (result.ok) {
      return resData;
    } else {
      throw new Error('something wrong');
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const updateSubscriptionDefaultPaymentMethod = async (
  url, 
  token,  
  customerId,
  subscriptionId,
  paymentMethodId,
) => {
  try {
    const result = await fetch(url + `/payment-method/update-subscription-default-payment-method`, {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        customerId: customerId,
        subscriptionId: subscriptionId,
        paymentMethodId: paymentMethodId,
      }),
    })

    const resData = await result.json()

    // console.log('meterEventSummarys', resData);

    if (result.ok) {
      return resData;
    } else {
      throw new Error('something wrong');
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const detachPaymentMethod = async (
  url, 
  token,  
  customerId,
  paymentMethodId,
) => {
  try {
    const result = await fetch(url + `/payment-method/detach-payment-method`, {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        customerId: customerId,
        paymentMethodId: paymentMethodId,
      }),
    })

    const resData = await result.json()

    // console.log('meterEventSummarys', resData);

    if (result.ok) {
      return resData;
    } else {
      throw new Error('something wrong');
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};